const cities = [
  {
    id: 236,
    name: "مشهد",
  },
  {
    id: 205,
    name: "تهران",
  },
];

export default cities;
